<app-header [hidden]="(!(this.userInfo?.roles == null))"></app-header>

<!-- TAM Main Details Card -->
<div class="container-fluid">
  <nz-card>
    <div class="col-md-20 downloadButton"></div>
     <div style="margin-top:10px; margin-bottom:10px; margin-left: 10px; margin-right: 20px; text-align:left;">
                        <button type="button"  style="background-color: #28a745; color: white; border: none; padding: 5px 5px;margin: 5px;font-size: 14px;  width: 10%"
                                (click)="goToMain()">
                          Back to List
                        </button>
      </div>

    <div class="ng-Header col-xs-15">
      <i nz-icon nzType="form" nzTheme="outline"></i> Training & Assessment Materials (TAM)
    </div>
    <div class="boxAerar">
      <div class="row" style="margin-left: 20px; padding-top: 20px; padding-right: 20px">
        <nz-descriptions nzSize="small" [nzColumn]="{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }">
          <nz-descriptions-item nzTitle="ID">
            {{ tamMain?.tamApplicationId || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Type">
            {{ tamMain?.tamType?.name || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Industry Sector">
            {{ tamMain?.tamOccupation?.tamIndustrialSector?.name || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Occupation">
            {{ tamMain?.tamOccupation?.name || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Level">
            {{ tamMain?.tamLevel?.levelNo || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Duration (Hours)">
            {{ tamMain?.duration || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Document Title">
            {{ tamMain?.docTitle || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Language">
            {{ tamMain?.tamLanguage?.name || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Version">
            {{ tamMain?.version || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Approval Date">
            {{ tamMain?.approvalDate ? (tamMain?.approvalDate | date: 'dd-MM-YYYY') : 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Source">
            {{ tamMain?.docSource || 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Received Date">
            {{ tamMain?.receivedDate ? (tamMain?.receivedDate | date: 'dd-MM-YYYY') : 'N/A' }}
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Funded By">
            {{ tamMain?.fundedBy || 'N/A' }}
          </nz-descriptions-item>
        </nz-descriptions>
      </div>
    </div>
  </nz-card>
</div>


<!-- Generic Competency Table -->
<div class="container-fluid" style="margin-top: 20px" *ngIf="varTamTypeSelectedId ===1">
  <nz-card [nzExtra]="extraGenericTemplate">
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="form" nzTheme="outline"></i> List of Generic Units Competency
    </div>
    <div class="boxAerar">
      <nz-table
        #genericTable
        [nzData]="genericCompetencies"
        nzShowSizeChanger
        nzBordered
        [nzTotal]="genericCompetencies.length"
        [(nzPageSize)]="size"
        [nzShowTotal]="totalRowRangeTemplate"
        [(nzPageIndex)]="page"
      >
        <ng-template #totalRowRangeTemplate let-range="range" let-total>
          <div>Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items</div>
        </ng-template>
        <thead>
        <tr>
          <th>Unit Code</th>
          <th>Title</th>
          <th>Duration</th>
          <th>Remarks</th>
          <th>Attachments</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of genericTable.data">
          <td>{{ data.unitCode }}</td>
          <td>{{ data.title }}</td>
          <td>{{ data.duration }}</td>
          <td>{{ data.remark }}</td>
          <td>
            <ng-container *ngIf="data.attachments && data.attachments.length > 0; else noAttachment">
              <ng-container *ngFor="let attachment of data.attachments">
                <button nz-button nzType="link" nz-tooltip nzTooltipTitle="Preview Attachment"
                        (click)="setBase64AttachmentforPreview(attachment)">
                  <i nz-icon nzType="eye"></i>
                </button>
                {{ getCleanFileTitle(attachment.attachmentTitle) }}<br/>
              </ng-container>
            </ng-container>
            <ng-template #noAttachment>
              N/A
            </ng-template>
          </td>
          <td style="text-align: center; vertical-align: middle;">
            <button nz-button nzType="default" nzSize="small" (click)="onDownloadAttachments(data)">
              <i nz-icon nzType="download"></i> Download Zip
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
    </div>
  </nz-card>
</div>

<!-- Specific Competency (Sector Data) Table -->
<div class="container-fluid" style="margin-top: 20px" *ngIf="varTamTypeSelectedId ===1">
  <nz-card>
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="form" nzTheme="outline"></i> List of Specific Unit of Competency
    </div>
    <div class="boxAerar">
      <nz-table
        #specificTable
        [nzData]="specificCompetencies"
        nzShowSizeChanger
        nzBordered
        [nzTotal]="specificCompetencies.length"
        [(nzPageSize)]="size"
        [nzShowTotal]="totalRowRangeTemplate2"
        [(nzPageIndex)]="page"
      >
        <ng-template #totalRowRangeTemplate2 let-range="range" let-total>
          <div>Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items</div>
        </ng-template>
        <thead>
        <tr>
          <th>Unit Code</th>
          <th>Title</th>
          <th>Sector</th>
          <th>Level</th>
          <th>Version</th>
          <th>Language</th>
          <th>Access Type</th>
          <th>Approval Date</th>
          <th>Remarks</th>
          <th>Attachments</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of specificTable.data">
          <td>{{ data.unitCode }}</td>
          <td>{{ data.title }}</td>
          <td>{{ data.sector }}</td>
          <td>{{ data.level }}</td>
          <td>{{ data.version }}</td>
          <td>{{ data.language }}</td>
          <td>{{ data.accessType }}</td>
          <td>{{ data.approvalDate ? (data.approvalDate | date: 'dd-MM-YYYY') : 'N/A' }}</td>
          <td>{{ data.remark }}</td>
          <td>
            <ng-container *ngIf="data.attachments && data.attachments.length > 0; else noAttachment">
              <ng-container *ngFor="let attachment of data.attachments">
                <button nz-button nzType="link" nz-tooltip nzTooltipTitle="Preview Attachment"
                        (click)="setBase64AttachmentforPreview(attachment)">
                  <i nz-icon nzType="eye"></i>
                </button>
                {{ getCleanFileTitle(attachment.attachmentTitle) }}<br/>
              </ng-container>
            </ng-container>
            <ng-template #noAttachment>
              N/A
            </ng-template>
          </td>
          <td style="text-align: center; vertical-align: middle;">
            <button nz-button nzType="default" nzSize="small" (click)="onDownloadAttachments(data)">
              <i nz-icon nzType="download"></i> Download Zip
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
    </div>
  </nz-card>
</div>

<!-- Occupation Competency Table -->
<div class="container-fluid" style="margin-top: 20px" *ngIf="varTamTypeSelectedId ===1">
  <nz-card>
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="form" nzTheme="outline"></i> List of Occupation Units of Competency
    </div>
    <div class="boxAerar">
      <nz-table
        #occupationTable
        [nzData]="occupationCompetencies"
        nzShowSizeChanger
        nzBordered
        [nzTotal]="occupationCompetencies.length"
        [(nzPageSize)]="size"
        [nzShowTotal]="totalRowRangeTemplate3"
        [(nzPageIndex)]="page"
      >
        <ng-template #totalRowRangeTemplate3 let-range="range" let-total>
          <div>Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items</div>
        </ng-template>
        <thead>
        <tr>
          <th>Unit Code</th>
          <th>Title</th>
          <th>Occupation</th>
          <th>Level</th>
          <th>Access Type</th>
          <th>Approval Date</th>
          <th>Attachments</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of occupationTable.data">
          <td>{{ data.unitCode }}</td>
          <td>{{ data.title }}</td>
          <td>{{ data.occupationName || data.tamMain?.tamOccupation?.name }}</td>
          <td>{{ data.level || data.tamMain?.tamLevel?.levelNo }}</td>
          <td>{{ data.accessType }}</td>
          <td>{{ data.approvalDate ? (data.approvalDate | date: 'dd-MM-YYYY') : 'N/A' }}</td>
          <td>
            <ng-container *ngIf="data.attachments && data.attachments.length > 0; else noAttachment">
              <ng-container *ngFor="let attachment of data.attachments">
                <button nz-button nzType="link" nz-tooltip nzTooltipTitle="Preview Attachment"
                        (click)="setBase64AttachmentforPreview(attachment)">
                  <i nz-icon nzType="eye"></i>
                </button>
                {{ getCleanFileTitle(attachment.attachmentTitle) }}<br/>
              </ng-container>
            </ng-container>
            <ng-template #noAttachment>
              N/A
            </ng-template>
          </td>
          <td style="text-align: center; vertical-align: middle;">
            <button nz-button nzType="default" nzSize="small" (click)="onDownloadAttachments(data)">
              <i nz-icon nzType="download"></i> Download Zip
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
    </div>
  </nz-card>
</div>



<div *ngIf="varTamTypeSelectedId ===2">
  <app-cad-equipment-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-equipment-table>

  <app-cad-measuring-instrument-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-measuring-instrument-table>

  <app-cad-tool-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-tool-table>

  <app-cad-material-consumable-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-material-consumable-table>

  <app-cad-ppe-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-ppe-table>

  <app-cad-furniture-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-furniture-table>

  <app-cad-learning-material-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-learning-material-table>

  <app-cad-training-facility-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-training-facility-table>

  <app-cad-trainer-and-staff-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-trainer-and-staff-table>

  <app-cad-other-requirement-table
    [tamMainId]="tamMainId"
    [createButton]="showCreateButton"
  ></app-cad-other-requirement-table>
</div>


<!--  CBLM data start -->


<!-- generic-->
 
 
<!--<div class="container-fluid" style="margin-top: 20px" *ngIf="varTamTypeSelectedId ===4">
  <nz-card>
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="form" nzTheme="outline"></i> List of Sector Competency
    </div>
    <div class="boxAerar">
      <nz-table
        #CBLMsectorTable
        [nzData]="cblmListSector"
        nzShowSizeChanger
        nzBordered
        [nzTotal]="cblmListSector.length"
        [(nzPageSize)]="size"
        [nzShowTotal]="totalRowRangeTemplateCBLMSector"
        [(nzPageIndex)]="page"
      >
        <ng-template #totalRowRangeTemplateCBLMSector let-range="range" let-total>
          <div>Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items</div>
        </ng-template>
        <thead>
        <tr>
          <th>Unit Code</th>
          <th>Title</th>
          <th>Duration</th>
          <th>Remarks</th>
          <th>Attachments</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of cblmListSector">
          <td>{{ data.unitcode }}</td>
          <td>{{ data.title }}</td>
          <td>{{ data.duration }}</td>
          <td>{{ data.remark }}</td>
          <td>
            <ng-container *ngIf="data.attachments && data.attachments.length > 0; else noAttachment">
              <ng-container *ngFor="let attachment of data.attachments">
                <button nz-button nzType="link" nz-tooltip nzTooltipTitle="Preview Attachment"
                        (click)="setBase64AttachmentforPreview(attachment)">
                  <i nz-icon nzType="eye"></i>
                </button>
                {{ getCleanFileTitle(attachment.attachmentTitle) }}<br/>
              </ng-container>
            </ng-container>
            <ng-template #noAttachment>
              N/A
            </ng-template>
          </td>
          <td style="text-align: center; vertical-align: middle;">
            <button nz-button nzType="default" nzSize="small" (click)="onDownloadAttachments(data)">
              <i nz-icon nzType="download"></i> Download Zip
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
    </div>
  </nz-card>
</div>-->
<!--  CBLM data end -->

    <app-cblm-generic-data>

    </app-cblm-generic-data>



    <app-cblm-sector-data>

    </app-cblm-sector-data>


    <!-- <app-cblm-occupation-specific-table
          
     >
     </app-cblm-occupation-specific-table>-->

<!-- Attachment Preview Modal -->
<nz-modal
  [(nzVisible)]="isVisibleForAttachment"
  nzTitle="Attachment Preview"
  (nzOnCancel)="handleCancelFile()"
  [nzFooter]="null"
  [nzWidth]="1200">
  <ng-container *nzModalContent>
    <div *ngIf="pdfUrl; else imagePreview">
      <iframe [src]="pdfUrl" width="100%" style="height: 35vw;" frameborder="0"></iframe>
    </div>
    <ng-template #imagePreview>
      <div style="text-align: center;">
        <img *ngIf="imageURL" [src]="imageURL" class="img-thumbnail" alt="Attachment Preview" style="max-width: 100%;"/>
      </div>
    </ng-template>
  </ng-container>
  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="handleCancelFile()">Close</button>
  </div>
</nz-modal>



<div style="margin-top:10px; margin-bottom:10px; margin-left: 20px; text-align:center;">
  <button type="button"  style="background-color: #28a745; color: white; border: none; padding: 5px 5px;margin: 5px;font-size: 14px;  width: 10%"
          (click)="goToMain()">
    Back to List
  </button>
</div>

<app-footer [hidden]="(!(this.userInfo?.roles == null))"></app-footer>